module.exports = __webpack_public_path__ + "static/media/bt_bg1_30.01ea68c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bt_bg1_30.png
// module id = 1740
// module chunks = 0 1